import type { Theme } from '@mui/material/styles'

export const shapeBorderRadius = (theme: Theme): string => `${theme.shape.borderRadius}px`
